<div id="lomia-cta-mobile-control" class="leaflet-bar leaflet-control">
    <stButton
        *ngIf="isShown"
        class="cta-button-wrapper"
        iconLeft="fa fa-sun-o fa-2x me-3"
        btnLabel="Mon projet solaire"
        (onClick)="toggleSolarModule()"
    ></stButton>
</div>
